// Custom css
import './assets/css/portal-style-new.scss'
import 'maplibre-gl/dist/maplibre-gl.css'

import './assets/js/portal.js'

import defaultFavicon from './assets/img/favicon.png'
import defaultLogo from './assets/img/realsam-logo-invisible.png'
import defaultLogoDark from './assets/img/realsam-logo-negative.png'

import Vue from 'vue'
import axios from 'axios'

import vuetify from './plugins/vuetify'

import store from './store/index'


// Setup global axios config 
Vue.use({
  install (Vue) {
    Vue.prototype.$api = axios.create({
      baseURL: '/api/v1/',
      headers: {'x-requested-with': 'XMLHttpRequest'}
    })
  }
})

new Vue({
  el: '#app',
  store,
  components: {
    'login': () => import('./components/pages/Login.vue'),
    'dashboard': () => import('./components/pages/Dashboard.vue'),
    'catalogue': () => import('./components/pages/Catalogue.vue'),
    'contact-management': () => import('./components/pages/ContactManagement.vue'),
    'find-my-pocket': () => import('./components/pages/FindMyPocket.vue'),
    'shop': () => import('./components/pages/Shop.vue'),
    'utility': () => import('./components/pages/utility/Index.vue'),
    'register-calibre-credential': () => import('./components/pages/utility/RegisterCalibreCredential.vue'),
    'generate-speaker-key': () => import('./components/pages/utility/GenerateSpeakerKey.vue'),
    'pop-up-message': () => import('./components/snippets/PopUpMessage.vue'),
    'setting': () => import('./components/pages/setting/Index.vue'),
    'change-password': () => import('./components/pages/setting/ChangePassword.vue'),
    'reset-password': () => import('./components/pages/ResetPassword.vue'),
    'privacy-policy': () => import('./components/pages/PrivacyPolicy.vue'),
    'terms-and-conditions': () => import('./components/pages/TermsAndConditions.vue'),
    'contact-us': () => import('./components/pages/ContactUs.vue'),
    'error-page': () => import('./components/pages/ErrorPage.vue'),
    'bookshelf': () => import('./components/pages/Bookshelf.vue'),
    'favorite-radio': () => import('./components/pages/FavoriteRadio.vue'),
    'favorite-podcast': () => import('./components/pages/FavoritePodcast.vue'),
    'my-device': () => import('./components/pages/MyDevice.vue'),
    'change-customer-info': () => import('./components/pages/setting/ChangeCustomerInfo.vue'),
    'message-management': () => import('./components/pages/MessageManagement.vue'),
    'call-logs-management': () => import('./components/pages/CallLogsManagement.vue'),
  },
  data: function() {
    return {
      isCatalogueAvailable: false,
      defaultBrandingAssets: {
        logoUrl: defaultLogo,
        logoUrlDark: defaultLogoDark,
        faviconUrl: defaultFavicon,
      },
      hasBookclubService: false
    }
  },
  computed: {
    brandingLogo() {
      return this.$store.getters.getBranding.logoUrl || this.defaultBrandingAssets.logoUrl
    },
    brandingLogoDark() {
      return this.$store.getters.getBranding.logoUrlDark
        || this.$store.getters.getBranding.logoUrl
        || this.defaultBrandingAssets.logoUrlDark
    },
    brandingFavicon() {
      return this.$store.getters.getBranding.faviconUrl || this.defaultBrandingAssets.faviconUrl
    },
    brandingPortalName() {
      return this.$store.getters.getBranding.portalName || ''
    },
  },
  mounted() {
    this.interceptAxios()
    this.applyBranding()
    this.fetchBranding()
    if (this.$store.getters.getUser !== null) {
      this.getContentSources()

      this.getMyDevices((data) => {
      for (const item of data.result) {
        if (item.service.server.startsWith("bookclub")) {
            this.hasBookclubService = true
            break
        }
      }
    })
    }
    
  },
  vuetify,
  methods: {
    fetchBranding() {
      let params = new URLSearchParams()
      params.append("domain", window.location.host)

      this.axiosRequest("get", "/branding/config/", params,
        (response) => {
          if (response.data && response.data.status === "success"
              && Array.isArray(response.data.result)
              && response.data.result.length > 0) {
            this.$store.commit("setBranding", response.data.result[0])
            this.applyBranding()
          }
        },
        (error) => {
          console.error("Failed to fetch branding config:", error.message)
        },
        () => {})
    },
    applyBranding() {
      const branding = this.$store.getters.getBranding || {}

      if (branding.portalName) {
        document.title = branding.portalName
      }

      this.updateFavicon(branding.faviconUrl || this.defaultBrandingAssets.faviconUrl)

      const themes = this.$vuetify && this.$vuetify.theme && this.$vuetify.theme.themes
      if (themes) {
        const apply = (themeName) => {
          if (branding.primaryColor) themes[themeName].primary = branding.primaryColor
          if (branding.secondaryColor) themes[themeName].secondary = branding.secondaryColor
          if (branding.accentColor) themes[themeName].accent = branding.accentColor
        }
        apply('light')
        apply('dark')
      }
    },
    updateFavicon(url) {
      if (!url) return
      let link = document.querySelector("link[rel='icon']")
        || document.querySelector("link[rel*='icon']")
      if (!link) {
        link = document.createElement("link")
        link.rel = "icon"
        document.head.appendChild(link)
      }
      link.href = url
    },
    dateToString(date) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate();

      return [date.getFullYear(),
          (mm>9 ? '' : '0') + mm,
          (dd>9 ? '' : '0') + dd
         ].join('-');
    },
    isParamsInUrl() {
      var url = window.location.href
      return url.split("?").length > 1
    },
    getParamsFromUrl() {
      return new URLSearchParams(window.location.search);
    },
    getMenu(location) {
      let country = this.getCountryBasedOnDomain()
      // let hasBookclubService = await this.hasBookclubService()
      // console.log("hasBookclubService", hasBookclubService)

      let menus = [
        {
          title: "Dashboard",
          url: "/dashboard",
          icon: "mdiViewDashboard",
          isEnabled: (location !== 'dashboard'),
        },
        {
          title: "Contact Management",
          img: "icondashboard",
          icon: "mdiAccountBox",
          url: "/contact",
          isEnabled: true
        },
        {
          title: "Catalogue Browsing",
          img: "iconcatalouge",
          icon: "mdiBookMultiple",
          url: "/catalogue",
          isEnabled: this.isCatalogueAvailable
        },
        {
          title: "Messages",
          img: "iconmessage",
          icon: "mdiEmail",
          url: "/message",
          isEnabled: true
        },
        {
          title: "Call Logs",
          img: "iconsmartphone",
          icon: "mdiCellphone",
          url: "/call-logs",
          isEnabled: true
        },
        {
          title: "Shop",
          img: "iconshop",
          icon: "mdiShopping",
          url: "/shop",
          isEnabled: ["au", "uk"].includes(country)
        },
        {
          title: "BookClub Activation Code",
          img: "iconkey",
          icon: "mdiKey",
          url: "/utility/generate-speaker-key",
          isEnabled: this.hasBookclubService
        },
        {
          title: "Utility",
          img: "iconutility",
          icon: "mdiToolbox",
          url: "/utility",
          isEnabled: !this.$root.isUS()
        },
        {
          title: "User Settings",
          img: "iconusersettings",
          icon: "mdiCog",
          url: "/setting",
          isEnabled: !this.$root.isUS()
        },
        {
          title: "Settings",
          img: "iconusersettings",
          icon: "mdiToolbox",
          url: "/utility",
          isEnabled: this.$root.isUS()
        },
        {
          title: "My Device",
          img: "iconsmartphone",
          icon: "mdiCellphone",
          url: "/my-device",
          isEnabled: true
        },
        {
          title: "Contact Us",
          img: "iconsupport",
          icon: "mdiFaceAgent",
          url: "/dashboard/contact-us",
          isEnabled: true
        },
      ]
      
      return menus.filter( menu => {
        return menu.isEnabled
      })

    },
    getContentSources() {
      // This method will get the content source like book, radio, etc
      //  based on the user's org service
      //  If the service does not have any content source then we can hide
      //  the catalogue menu.
      let params = new URLSearchParams()

      this.axiosRequest("get", "/catalogue/content-types", params, 
        (response) => {
          console.log(response.data)
          // On success.
          if (response.data.status === "success") {
            if (response.data.result.length > 0) {
              this.isCatalogueAvailable = true
            }
          }
        }, 
        (error) => {
          console.error(error.message)
          // On error.
        },
        () => {
          // Finally
        })
    },
    getCountryBasedOnDomain() {
      // Get the country of the website based on domain.
      // Currently only support realsam.co.uk (UK) and realsam.us (US)
      // Possible returned value us, uk or au
      let domain = window.location.hostname
      let countryDomain = domain.split(".").pop()
      let possibleCountry = ["us", "uk", "au"]
      
      if (possibleCountry.includes(countryDomain)) {
        return countryDomain
      }
      
      // Default country
      return "us"
      
    },
    getDomain() {
      // Hostname and port when non-default (e.g. localhost:8080).
      return window.location.host
    },
    isUS(){
      let country = this.getCountryBasedOnDomain()
      if (["us"].includes(country)) {
				return true
			}
			return false
    },
    addressStringBuilder(addressObj) {
      // If the address id is 0, it means the user has null value for address
      if (addressObj === null || addressObj.id === 0) return "-"

      let addressArr = []
      if (addressObj.line1 !== "") addressArr.push(addressObj.line1)
      if (addressObj.line2 !== "") addressArr.push(addressObj.line2)

      // Postal code is attached to state if it exists otherwise it is attached to city 
      if (addressObj.state !== null && addressObj.state.id !== 0) {
        if (addressObj.city !== "") 
          addressArr.push(addressObj.city)

        addressArr.push(addressObj.state.name + " " + addressObj.postalCode)
      } else {
        if (addressObj.city !== "") 
          addressArr.push(addressObj.city + " " + addressObj.postalCode)
      }

      if (addressObj.country !== null) 
        addressArr.push(addressObj.country.name)
      
      if (addressArr.length === 0) return "-"

      return addressArr.join(", ")
    },
    getMyDevices(successCallback) {
      let params = new URLSearchParams()
      let apiUrl = "/my-device/get-my-device"

      this.$root.axiosRequest("get", apiUrl, params, 
        (response) => {
          // On success.
          if (response.data.status === "success") {
            successCallback(response.data)
          }
        }, 
        (error) => {
          // On error.
        },
        () => {
          // Finally
        })
    },

    axiosRequest(method, url, params, successCallback, errorCallback, finallyCallback, headers=null){
      let config = {
        method: method,
        url: url,
      }

      if (method === "post") {
        // config.data must be an instance of URLSearchParams
        config.data = params
      } else if (method === "get") {
        config.params = params
      }

      if (headers) {
        config.headers = headers
      }

      let self = this

      this.$api.request(config)
      .then(response => {
        if ("action" in response.data) {
          if (response.data.action === "reauth") {
            return self.removeExpiredToken()
          }
        }
        successCallback(response)
      })
      .catch(error => {
        // console.log(error)
        errorCallback(error)
      })
      .finally(() => {
        finallyCallback()
      })
    },
    removeExpiredToken() {
      let params = new URLSearchParams()
      params.append("next", window.location.href)
      this.axiosRequest("post", "/auth/remove-expired-token/", params, 
        (response) => {
          // On success.
          // console.log(response)
          if (response.data.status === "success") {
            sessionStorage.clear()
            window.location.href = response.data.redirect
          }
        }, 
        (error) => {
          // On error.
          console.error(error.message)
        },
        () => {
          // Finally
        })
    },
    interceptAxios() {
      var self = this
      this.$api.interceptors.response.use(function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        return response;
      }, function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        if (error.response) {
          // Request made and server responded
          console.log(error.response);
          if (error.response.status === 403 && error.response.headers.refresh_url) {
            // document.location.href = window.location.href;
            self.$root.$emit('popUpMessage', 'refreshSession')
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
        }
  
        return Promise.reject(error);
      });
    }
  }
});
